import { useCallback, useEffect, useState } from "react";
import { faRedo, faUndo, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { LexicalCommand, COMMAND_PRIORITY_LOW, UNDO_COMMAND, REDO_COMMAND, CAN_UNDO_COMMAND, CAN_REDO_COMMAND } from "lexical";
import ToolbarButton from "../../../components/ToolbarButton";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { icon } from "@fortawesome/fontawesome-svg-core";

type UndoRedoProperties =
{
    command: LexicalCommand<void>
    canCommand: LexicalCommand<boolean>
    title: string
    icon: IconDefinition
}

function UndoRedo({ command, canCommand, title, icon }: UndoRedoProperties)
{
    const [editor] = useLexicalComposerContext();
    const [enabled, setEnabled] = useState(false);
    useEffect(() =>
    {
        return editor.registerCommand(canCommand, available => { setEnabled(available); return false; }, COMMAND_PRIORITY_LOW );
    },
    [editor, canCommand]);
    const handleClick = useCallback(() => { editor.dispatchCommand(command, null as unknown as void); }, [editor, command]);
    return <ToolbarButton title={title} icon={icon} enabled={enabled} onClick={handleClick} />;
}

export function Undo()
{
    return <UndoRedo title={'Undo'} icon={faUndo} command={UNDO_COMMAND} canCommand={CAN_UNDO_COMMAND} />;
}

export function Redo()
{
    return <UndoRedo title={'Redo'} icon={faRedo} command={REDO_COMMAND} canCommand={CAN_REDO_COMMAND} />;
}